// card-sharks — the in-page privacy policy (nodejavascript.com site standard, part 4).
import React from 'react'

import policyHtml from '../privacyPolicy'

// card-sharks — the privacy policy, IN THE PAGE (nodejavascript.com site standard, parts 1b and 4).
//
// 🔴 IT USED TO BE A PAGE OF ITS OWN, `public/privacy.html`, AND THAT IS NO LONGER ALLOWED.
// George, 19 September 2026, verbatim: *"i dont like privacy html anywhere remember that for the
// rules"*. A separate policy is a second document that has to be kept separately true, and it is
// the one nobody rereads — it drifts from the code because nothing makes the two agree. Here it
// sits beside what it describes, ships in the same build, and arrives with the page that already
// loaded: following the footer's `#privacy` link is not a second visit.
//
// The markup is the same text the old page served — carried as a string so nothing was retyped.
// Only one change was made to it: the single `<h1>` became an `<h2>`, because this page has
// exactly one `<h1>` (part 3) and the policy is a section of it.
const Privacy = () => (
  <section id='privacy' className='dvs-privacy'>
    <div dangerouslySetInnerHTML={{ __html: policyHtml }} />
  </section>
)

export default Privacy
